import { render, staticRenderFns } from "./Table-all-aseguradora.vue?vue&type=template&id=0ff5a0ca&"
import script from "./Table-all-aseguradora.vue?vue&type=script&lang=js&"
export * from "./Table-all-aseguradora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports